import { ICON_TYPES } from '../constants';

export const SpinnerIcon = (): JSX.Element => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM7.04 32C7.04 45.785 18.215 56.96 32 56.96C45.785 56.96 56.96 45.785 56.96 32C56.96 18.215 45.785 7.04 32 7.04C18.215 7.04 7.04 18.215 7.04 32Z"
        fill="#E35205"
        fillOpacity="0.2"
      />
      <path
        d="M32 0C38.329 7.54726e-08 44.5159 1.87677 49.7782 5.39297C55.0406 8.90918 59.1421 13.9069 61.5641 19.7541C63.9861 25.6014 64.6199 32.0355 63.3851 38.2429C62.1504 44.4503 59.1027 50.1521 54.6274 54.6274C50.1521 59.1027 44.4503 62.1504 38.2429 63.3851C32.0355 64.6199 25.6014 63.9861 19.7541 61.5641C13.9069 59.1421 8.90918 55.0406 5.39297 49.7782C1.87677 44.5159 -1.50945e-07 38.329 0 32H7.04C7.04 36.9366 8.50388 41.7624 11.2465 45.867C13.9892 49.9717 17.8874 53.1709 22.4482 55.06C27.0091 56.9492 32.0277 57.4435 36.8695 56.4804C41.7112 55.5173 46.1587 53.1401 49.6494 49.6494C53.1401 46.1587 55.5173 41.7112 56.4804 36.8695C57.4435 32.0277 56.9492 27.0091 55.06 22.4482C53.1709 17.8874 49.9717 13.9892 45.867 11.2465C41.7624 8.50388 36.9366 7.04 32 7.04V0Z"
        fill="#E35205"
      />
    </svg>
  );
};

SpinnerIcon.iconType = ICON_TYPES.SPINNER;
